import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import Icon from '@components/common/Icon';

export interface CheckboxProps {
    label?: string;
    registration?: UseFormRegisterReturn;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    id?: string;
    className?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, registration, checked, onChange, id, className = '' }, ref) => {
        const inputId = id ?? registration?.name ?? label?.toLowerCase().replace(/\s+/g, '-');

        return (
            <label
                htmlFor={inputId}
                className={`inline-flex items-center gap-2 cursor-pointer select-none ${className}`}
            >
                <div className="relative flex-shrink-0 w-4 h-4">
                    <input
                        id={inputId}
                        type="checkbox"
                        ref={(node) => {
                            if (registration?.ref) registration.ref(node);
                            if (typeof ref === 'function') ref(node);
                            else if (ref) (ref as React.MutableRefObject<HTMLInputElement | null>).current = node;
                        }}
                        {...registration}
                        {...(onChange !== undefined
                            ? {
                                checked,
                                onChange: (e) => onChange(e.target.checked),
                            }
                            : {})}
                        className="peer appearance-none w-4 h-4 border border-[var(--secondary-subtitle-color)] rounded cursor-pointer
                                   checked:bg-[var(--secondary-color)] checked:border-[var(--secondary-color)]
                                   transition-colors"
                    />
                    <span className="absolute inset-0 flex items-center justify-center pointer-events-none hidden peer-checked:flex">
                        <Icon name="checkboxCheck" size={16} alt="" />
                    </span>
                </div>

                {label && (
                    <span className="text-[12px] 2xl:text-[14px] text-[var(--secondary-color)]">
                        {label}
                    </span>
                )}
            </label>
        );
    },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;